import { SagaIterator } from 'redux-saga'
import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects'

import {
  CATALOGOS_SET_IS_DELETE,
  CATALOGOS_SET_IS_EDIT,
  CATALOGOS_SET_LISTASELECCION,
  CATALOGOS_SET_LISTASELECCION_DATA,
  CAT_EDIT_LISTA_SELECCION,
  CAT_ELIMINAR_LS,
  CAT_OPEN_EDITING,
  CAT_OPEN_ELIMINAR,
  CAT_SET_AMBITO_SELECTED,
  CAT_SET_CURRENT_LS,
  CAT_SET_PROCESS_EDIT,
} from './CatalogosTypes'

import { RootState } from '../store'

import {
  deleteListaSeleccion,
  putListaSeleccion,
} from '@/common/helpers/apiCatalogo'
import { notifications } from '@/common/helpers/notifications'
import { Action } from '@/common/interfaces/general'
import { ListaSeleccion } from '@/common/interfaces/listaSeleccion'
import { invalidarListaSeleccion } from '@/common/services/invalidarCatalogos'

function* activeButtons(): Generator {
  yield put({ type: CATALOGOS_SET_IS_EDIT, payload: false })
  yield put({ type: CATALOGOS_SET_IS_DELETE, payload: false })
}

function* eliminarCatalogoLS({ payload }: Action<ListaSeleccion>): SagaIterator {
  const { listaSeleccionData, listaSeleccion } = yield select(
    (state: RootState) => state.Catalogos,
  )

  yield put({ type: CATALOGOS_SET_IS_DELETE, payload: true })
  try {
    yield call(deleteListaSeleccion, payload.ListaSeleccionId)
    // Los combos que salen de este ambito se sirven de la cache de RTK Query, que no se
    // entera de este cambio: el CRUD va por helper HTTP, no por el api.
    yield put(invalidarListaSeleccion(payload.Ambito))
    const listaSeleccionExcluidaEliminada = listaSeleccionData.filter(
      (ls: ListaSeleccion) => ls.ListaSeleccionId !== payload.ListaSeleccionId,
    )

    yield put({
      type: CATALOGOS_SET_LISTASELECCION_DATA,
      payload: listaSeleccionExcluidaEliminada,
    })
    yield put({ type: CAT_SET_CURRENT_LS, payload: {} })
    let nuevalistaSeleccion

    if (Object.values(listaSeleccion[payload.Ambito]).length === 1) {
      yield put({ type: CAT_SET_AMBITO_SELECTED, payload: '' })
      const { ...nuevaLista } = listaSeleccion

      nuevalistaSeleccion = { ...nuevaLista }
    } else {
      const { [payload.Ambito]: listaAfectada, ...nuevaLista } = listaSeleccion
      const { ...otros } = listaAfectada

      nuevalistaSeleccion = { ...nuevaLista, [payload.Ambito]: otros }
    }
    yield put({
      type: CATALOGOS_SET_LISTASELECCION,
      payload: nuevalistaSeleccion,
    })
    yield put({ type: CATALOGOS_SET_IS_EDIT, payload: true })
    yield put({ type: CATALOGOS_SET_IS_DELETE, payload: true })

    notifications({
      title: 'Éxito',
      message: `Catálogo Eliminado`,
      toastType: 'success',
    })
  } catch (error) {
    notifications({ ex: error })
    yield put({ type: CATALOGOS_SET_IS_EDIT, payload: false })
    yield put({ type: CATALOGOS_SET_IS_DELETE, payload: false })
  } finally {
    yield put({ type: CAT_OPEN_ELIMINAR, payload: false })
  }
}

function* editandoCatalogoLS({ payload }: Action<ListaSeleccion>): SagaIterator {
  const { listaSeleccionData } = yield select(
    (state: RootState) => state.Catalogos,
  )

  try {
    yield put({ type: CAT_OPEN_EDITING, payload: false })
    yield call(putListaSeleccion, payload)
    // Los combos que salen de este ambito se sirven de la cache de RTK Query, que no se
    // entera de este cambio: el CRUD va por helper HTTP, no por el api.
    yield put(invalidarListaSeleccion(payload.Ambito))
    const listaSeleccionUpdate = listaSeleccionData.map(
      (ls: ListaSeleccion) => {
        if (ls.ListaSeleccionId === payload.ListaSeleccionId) {
          return { ...payload, selected: true }
        }

        return ls
      },
    )

    yield put({
      type: CATALOGOS_SET_LISTASELECCION_DATA,
      payload: listaSeleccionUpdate,
    })
    notifications({
      title: 'Éxito',
      message: `Catálogo Actualizado`,
      toastType: 'success',
    })
  } catch (error) {
    notifications({ ex: error })
  } finally {
    yield put({ type: CAT_SET_PROCESS_EDIT, payload: false })
  }
}

function* watchEditarCatalogoLS(): Generator {
  yield takeLatest(CAT_EDIT_LISTA_SELECCION, editandoCatalogoLS)
}

function* watchEliminarLS(): Generator {
  yield takeLatest(CAT_ELIMINAR_LS, eliminarCatalogoLS)
}

function* watchCurrentCatalogoListaSeleccion(): Generator {
  yield takeLatest(CAT_SET_CURRENT_LS, activeButtons)
}

export default function* CatalogoListaSeleccionSaga(): Generator {
  yield all([
    fork(watchCurrentCatalogoListaSeleccion),
    fork(watchEliminarLS),
    fork(watchEditarCatalogoLS),
  ])
}
